import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { UserProfile } from '../contexts/AuthContext';

export const setupAdminUser = async (email: string, uid: string): Promise<void> => {
  try {
    // Check if admin profile already exists
    const adminDoc = await getDoc(doc(db, 'userProfiles', uid));
    
    if (adminDoc.exists()) {
      console.log('Admin profile already exists');
      return;
    }

    // Create admin profile
    const adminProfile: UserProfile = {
      uid,
      email,
      role: 'admin',
      displayName: 'Administrator',
      companyName: 'Avis Engineering & Consultancy',
      phone: '',
      createdAt: new Date().toISOString(),
      isActive: true,
    };

    await setDoc(doc(db, 'userProfiles', uid), adminProfile);
    console.log('Admin profile created successfully');
  } catch (error) {
    console.error('Error setting up admin user:', error);
    throw error;
  }
};

export const createAdminUser = async (email: string, password: string): Promise<void> => {
  try {
    const { createUserWithEmailAndPassword } = await import('firebase/auth');
    const { auth } = await import('../config/firebase');
    
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const uid = userCredential.user.uid;
    
    await setupAdminUser(email, uid);
    console.log('Admin user created successfully');
  } catch (error) {
    console.error('Error creating admin user:', error);
    throw error;
  }
};
